import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Checkbox } from 'components/ui';
import useCheckPermissions from 'hooks/auth/useCheckPermission';

const ToggleAllowDuplicates = () => {
  const { control } = useFormContext();
  const { userCheckPermission } = useCheckPermissions();
  const isAdmin = userCheckPermission('user.view');

  if (!isAdmin) return <></>;

  return (
    <Controller
      control={control}
      name="allow_duplicates"
      render={({ field: { value, onChange } }) => {
        return (
          <section className="send-mail-form__section">
            <div>
              <Checkbox
                checked={value}
                onChange={({ target: { checked } }) => {
                  onChange(checked);
                }}
              >
                Allow Duplicates
              </Checkbox>
            </div>
          </section>
        );
      }}
    />
  );
};

export default ToggleAllowDuplicates;
